export default __webpack_public_path__ + "static/media/archive.dbe60223.svg";